import React from 'react';
import classes from '../styles/style.module.css'
import CustomModal from '../../../assets/components/ModalComonent';

const IntroduceDialog = ({ open, onClose }) => {
    const AwardsContent =
        <div>
            <img src='/images/hubble/dialogs/introduce.png' className='w-75' alt='awards' />
            <h4 className={classes.dialogHeading}>معرفی رویداد</h4>
            <p style={{textAlign:'justify'}}>
                🔭هابل؛ رصدخانه‌ی استعدادهای آسمانِ فولاد مبارکه است...
                <br />
                🔻ما اینجا هستیم تا استعدادهای خانواده بزرگ مجتمع فولاد مبارکه اصفهان را رصد و شناسایی کنیم.
                استعدادیابی فرایندی است که در آن مهارت‌ها، توانایی‌ها و پتانسیل‌های نهفته‌ی افراد شناسایی شده و در مسیر رشد و توسعه قرار می‌گیرند. در واقع، استعدادیابی به کشف استعدادهای ذاتی در حوزه‌های مختلف کمک می‌کند تا افراد بتوانند در مسیر درست پیشرفت کنند. جشنواره استعدادیابی هابل با هدف کشف، پرورش و حمایت از استعدادهای برتر برگزار می‌شود و فرصتی را فراهم می‌کند تا افراد بتوانند توانایی‌های خود را در یک فضای رقابتی و حرفه‌ای به نمایش بگذارند.
            </p>
        </div>


    return (
        <div>
            <CustomModal
                yellow
                open={open}
                closeHandler={onClose}
                inputDialog={true}
                dialogContent={AwardsContent}
            />
        </div>
    )
}

export default IntroduceDialog